import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import { App } from './App';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { EpisodePage } from './pages/EpisodePage';
import { ScenePage } from './pages/ScenePage';
import { AdminPage } from './pages/AdminPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { initSaveQueue } from './state/saveQueue';

import './styles/global.css';

void initSaveQueue();

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'episode/:uuid', element: <EpisodePage /> },
      { path: 'episode/:uuid/scene/:sceneId', element: <ScenePage /> },
      { path: 'admin/*', element: <AdminPage /> },
      { path: '403', element: <NotFoundPage kind="403" /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '/redirect-home', element: <Navigate to="/" replace /> },
]);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
